import api from '../lib/api';

const authApi = {
  login: async (values) => {
    const { data } = await api.post('/auth/login', values);
    return data;
  },
  me: async () => {
    const { data } = await api.get('/auth/me');
    return data;
  },
};

export default authApi;
